/* src/auth/reducers.js */

import { get } from 'lodash';

import {
  validateTokenTypes,
  loginTypes,
  verify2faTypes,
  fetchUserTypes,
  SELECT_UNIVERSITY,
  SELECT_ORGANIZATION,
  CLEAR_AUTH,
} from './action_types';

import { updateAdminNotificationPreferenceTypes } from '../profile/action_types';

import { makeRequestReducer } from '../../config/client';

export const INITIAL_STATE = {
  selectedUniversity: 'all',
  selectedOrganization: 'all',
};

export default makeRequestReducer({
  types: fetchUserTypes,
  name: 'adminSelf',
  initialData: { user: {}, token: '', token2fa: '' },
  initialState: INITIAL_STATE,
  mutate: (state, res) => ({ user: res }),
  append: [
    makeRequestReducer({
      types: loginTypes,
      name: 'login',
      mutate: (state, res) => {
        global.__token_nim = get(res, 'adminToken')
        return {
          token: get(res, 'adminToken'),
        };
      },
    }),
    makeRequestReducer({
      types: validateTokenTypes,
      name: 'validateToken',
      mutate: (state, res) => {
        global.__token_nim = get(res, 'adminToken')
        return {
          token: get(res, 'adminToken'),
        };
      },
    }),
    makeRequestReducer({
      types: verify2faTypes,
      name: 'verifyTwoFactor',
      mutate: (state, res) => {
        global.__token_nim = get(res, 'adminToken')
        return {
          ...state.data,
          token: get(res, 'adminToken'),
        };
      },
    }),
    makeRequestReducer({
      types: updateAdminNotificationPreferenceTypes,
      name: 'updateAdminNotificationPreference',
      mutate: (state, res) => ({ user: res }),
    }),
    (state, { type, payload }) => {
      switch (type) {
        case SELECT_UNIVERSITY:
          return { ...state, selectedUniversity: payload };
        case SELECT_ORGANIZATION:
          return { ...state, selectedOrganization: payload };
        case CLEAR_AUTH:
          return { ...state, data: {} };
        default:
          return state;
      }
    },
  ],
});



// WEBPACK FOOTER //
// ./src/modules/auth/reducers.js